'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'traffic-light-stop';
var width = 320;
var height = 512;
var aliases = [];
var unicode = 'f63a';
var svgPathData = ['M32 64l0 288c0 70.7 57.3 128 128 128s128-57.3 128-128l0-288c0-17.7-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64zm184 56a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm0 136a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm0 136a56 56 0 1 1 -112 0 56 56 0 1 1 112 0z', 'M64 32C46.3 32 32 46.3 32 64l0 288c0 70.7 57.3 128 128 128s128-57.3 128-128l0-288c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L256 0c35.3 0 64 28.7 64 64l0 288c0 88.4-71.6 160-160 160S0 440.4 0 352L0 64zM136 392a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM160 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 80a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm0-136a56 56 0 1 1 0-112 56 56 0 1 1 0 112z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTrafficLightStop = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;